export default ({ value }) => {
  let pass = true;
  pass = validateCreditCard(value);

  return pass;
};

const validateCreditCard = (value) => {
  const cleanedValue = value.replace(/\s/g, ''); // Boşlukları kaldır
  // 13-19 haneli kart numarası kontrolü
  if (/^3[47]/.test(cleanedValue)) {
    return /^[0-9]{15,16}$/.test(cleanedValue);
  }
  return /^[0-9]{16}$/.test(cleanedValue);
};
